import React, { useState } from 'react'
import './Alert.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { ALERT_TYPES } from './constants'

export default function Alert({
  type = ALERT_TYPES.WARNING,
  message,
  visible: externalVisible,
  onDismiss
}) {
  const [internalVisible, setInternalVisible] = useState(true)

  // Use external visibility control if provided, otherwise use internal state
  const isVisible = externalVisible !== undefined ? externalVisible : internalVisible

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss()
    } else {
      setInternalVisible(false)
    }
  }

  if (!isVisible) return null

  return (
    <div className={`alert alert--${type}`} role="alert">
      <span>{message}</span>
      <button className="alert__close" onClick={handleDismiss} aria-label="Close alert">
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  )
}
